/** KpiTile — premium KPI card with value, target delta and an animated sparkline. */
import React from 'react';
import { TrendingUp, TrendingDown, Sparkles, Info } from 'lucide-react';
import Sparkline from './Sparkline';

export default function KpiTile({ icon: Icon, label, value, sub, trend, color = '#10b981', delta, deltaGood, testid, ai, source }) {
  return (
    <div className="rounded-2xl qsr-card p-4 shadow-sm overflow-hidden" data-testid={testid}>
      <div className="flex items-center justify-between mb-1.5">
        <div className="flex items-center gap-1.5 text-xs text-slate-600 font-medium">
          {Icon && <Icon className="w-3.5 h-3.5" style={{ color }} />}{label}
        </div>
        <div className="flex items-center gap-1">
          {delta != null && (
            <span className={`inline-flex items-center gap-0.5 text-[11px] font-semibold ${deltaGood ? 'text-emerald-600' : 'text-rose-600'}`}>
              {deltaGood ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}{delta}
            </span>
          )}
        </div>
      </div>
      <div className="text-2xl font-semibold tracking-tight text-slate-900">{value}</div>
      {sub && <div className="text-[11px] text-slate-500 mt-0.5">{sub}</div>}
      {trend && <div className="mt-2 -mx-1"><Sparkline data={trend} color={color} width={200} height={34} className="w-full" /></div>}
      {ai && (
        <p className="mt-2 pt-2 border-t border-slate-100 text-[11px] leading-snug text-slate-600 flex gap-1.5" data-testid={testid ? `${testid}-insight` : undefined}>
          <Sparkles className="w-3 h-3 text-emerald-500 shrink-0 mt-0.5" />
          <span>{ai}</span>
        </p>
      )}
      {source && (
        <div className="mt-1.5 text-[10px] text-slate-500 flex items-center gap-1">
          <Info className="w-2.5 h-2.5 shrink-0" />{source}
        </div>
      )}
    </div>
  );
}
